/* eslint-disable import/prefer-default-export */
export const RESOLUTION_STATUS_QUERY_KEY = 'resolutionStatuses';
